<template>
  <CCard>
    <CCardHeader class="d-flex">
      <h2 class="mb-0">
        Invite Instructor
      </h2>
    </CCardHeader>
    <CCardBody>
      <form
        autocomplete="off"
        @submit.prevent="submit"
      >
        <CInput
          v-model="new_instructor.first_name"
          label="First Name"
          autocomplete="first-name"
          :add-input-classes="{ 'is-invalid': hasError('first_name') }"
          :invalid-feedback="getError('first_name')"
        />
        <CInput
          v-model="new_instructor.last_name"
          label="Last Name"
          autocomplete="last-name"
          :add-input-classes="{ 'is-invalid': hasError('last_name') }"
          :invalid-feedback="getError('last_name')"
        />
        <CInput
          v-model="new_instructor.email"
          label="Email"
          autocomplete="email"
          :add-input-classes="{ 'is-invalid': hasError('email') }"
          :invalid-feedback="getError('email')"
        />

        <div class="row my-3">
          <div class="col-md-6">
            <h4>Original Image</h4>
            <cropper
              v-if="image.src"
              ref="cropper"
              class="upload-example-cropper"
              :src="image.src"
              @change="onChange"
            />

            <CButton
              class="button"
              type="button"
              @click="$refs.file.click()"
            >
              <input
                ref="file"
                type="file"
                accept="image/*"
                @change="loadImage($event)"
              >
              Load image
            </CButton>
          </div>
          <div class="col-md-6">
            <h4>Cropped Image</h4>

            <preview
              v-if="result.image"
              :width="300"
              :height="300"
              :image="result.image"
              :coordinates="result.coordinates"
            />
          </div>
        </div>

        <CButton
          type="submit"
          color="primary"
        >
          Save
        </CButton>
      </form>
    </CCardBody>
  </CCard>
</template>

<script>
import hasApiValidation from '@/mixins/hasApiValidation';
import { Cropper, Preview } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';

function getMimeType(file, fallback = null) {
  const byteArray = new Uint8Array(file).subarray(0, 4);
  let header = '';
  for (let i = 0; i < byteArray.length; i++) {
    header += byteArray[i].toString(16);
  }
  switch (header) {
    case '89504e47':
      return 'image/png';
    case '47494638':
      return 'image/gif';
    case 'ffd8ffe0':
    case 'ffd8ffe1':
    case 'ffd8ffe2':
    case 'ffd8ffe3':
    case 'ffd8ffe8':
      return 'image/jpeg';
    default:
      return fallback;
  }
}

export default {
  name: 'InviteInstructor',
  components: {
    Cropper,
    Preview,
  },
  mixins: [hasApiValidation],
  data() {
    return {
      roles: [],
      result: {
        coordinates: null,
        image: null,
      },
      image: {
        src: null,
        type: null,
      },
      new_instructor: {
        first_name: '',
        last_name: '',
        email: '',
        image_base64: '',
      },
    };
  },
  mounted() {},
  unmounted() {
    if (this.image.src) {
      URL.revokeObjectURL(this.image.src);
    }
  },
  methods: {
    onChange({ coordinates, image }) {
      this.result = {
        coordinates,
        image,
      };
      const { canvas } = this.$refs.cropper.getResult();
      const base64Image = canvas.toDataURL(this.image.type);

      this.new_instructor.image_base64 = base64Image;
    },

    reset() {
      this.image = {
        src: null,
        type: null,
      };
    },
    loadImage(event) {
      // Reference to the DOM input element
      const { files } = event.target;
      // Ensure that you have a file before attempting to read it
      if (files && files[0]) {
        // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
        if (this.image.src) {
          URL.revokeObjectURL(this.image.src);
        }
        // 2. Create the blob link to the file to optimize performance:
        const blob = URL.createObjectURL(files[0]);

        // 3. The steps below are designated to determine a file mime type to use it during the
        // getting of a cropped image from the canvas. You can replace it them by the following string,
        // but the type will be derived from the extension and it can lead to an incorrect result:
        //
        // this.image = {
        //    src: blob;
        //    type: files[0].type
        // }

        // Create a new FileReader to read this image binary data
        const reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.image" refers to the image of Vue component
          this.image = {
            // Set the image source (it will look like blob:http://example.com/2c5270a5-18b5-406e-a4fb-07427f5e7b94)
            src: blob,
            // Determine the image type to preserve it during the extracting the image from canvas:
            type: getMimeType(e.target.result, files[0].type),
          };
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsArrayBuffer(files[0]);
      }
    },

    submit() {
      this.save();
    },
    save() {
      this.setErrors({});
      this.$http
        .post('/instructors', this.new_instructor)
        .then((data) => {
          this.$router.push({ name: 'Instructors' }).then(() => {
            this.$toast.success('Created');
          });
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
          this.setErrors(response.data.errors);
        });
    },
  },
};
</script>

<style scoped>
.upload-example-cropper {
  border: solid 1px #eee;
  min-height: 300px;
  max-height: 500px;
  width: 100%;
}

.button-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 17px;
}

.button {
  color: white;
  font-size: 16px;
  padding: 10px 20px;
  background: #007bff;
  cursor: pointer;
  transition: background 0.5s;
  width: 100%;
  text-align: center;
}

.button:hover {
  background: #1d5ca0;
}

.button input {
  display: none;
}
</style>
